export const getSumOfPropertyInAnArrayOfObjects = (arr: any, property: string): number => {
  return arr.reduce((a: number, b: any) => a + b[property], 0)
}
